import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Alert from '@amzn/awsui-components-react/polaris/alert';
import { publishCounterMetric } from '../../utils/metrics';
import CustomCalloutsErrorBoundary from './CustomCalloutsErrorBoundary';

const CustomCalloutsAlert = ({ alert }) => {
  const { header, content, type = 'info' } = alert;

  useEffect(() => {
    publishCounterMetric('CustomCallouts', {
      counterName: 'CustomCallout',
      additionalMetrics: {
        CalloutType: 'alert',
      },
    });
  }, []);

  return (
    <CustomCalloutsErrorBoundary>
      <Alert header={header} type={type}>
        {content}
      </Alert>
    </CustomCalloutsErrorBoundary>
  );
};

CustomCalloutsAlert.propTypes = {
  alert: PropTypes.shape({
    header: PropTypes.string,
    type: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,
};

export default CustomCalloutsAlert;
